import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const setRemixThinkingComplete =
	(isComplete: boolean): EditorCommand =>
	({ tr }) => {
		tr.setMeta(remixThinkingPluginKey, {
			lifecycle: { kind: isComplete ? 'legacy-complete' : 'legacy-complete-false' },
		} satisfies RemixThinkingPluginMeta);

		return tr;
	};

export const resetRemixThinkingPresentation: EditorCommand = ({ tr }) => {
	tr.setMeta(remixThinkingPluginKey, {
		presentation: { kind: 'reset' },
	} satisfies RemixThinkingPluginMeta);

	return tr;
};
